import { useState } from "react";

/** Pista de la Cuenta Familiar (Eduardo 2026-10-01): la primera vez que una
 * cuenta con 2 o más jugadores abre su home, una línea señala el selector
 * «Jugando como». Se cierra con «Entendido» y no vuelve (localStorage, por
 * cuenta). Si el navegador no deja guardar, se oculta por esta visita. */
export const FAMILY_TIP_KEY_PREFIX = "torneos123_family_tip_seen_";

export function familyTipKey(userId: number | string): string {
  return `${FAMILY_TIP_KEY_PREFIX}${userId}`;
}

function readSeen(key: string): boolean {
  try {
    return window.localStorage.getItem(key) === "1";
  } catch {
    // Navegación privada o almacenamiento bloqueado: se muestra.
    return false;
  }
}

export default function PlayerFamilyTip({ userId, count }: { userId: number | string | null | undefined; count: number }) {
  // Cuenta para la que se cerró en esta visita (sirve aunque no se guarde).
  const [hiddenFor, setHiddenFor] = useState<string | null>(null);
  const key = userId === null || userId === undefined ? null : familyTipKey(userId);
  if (!key || count < 2 || hiddenFor === key || readSeen(key)) return null;
  const storageKey = key;

  function dismiss() {
    setHiddenFor(storageKey);
    try {
      window.localStorage.setItem(storageKey, "1");
    } catch {
      // No se pudo guardar: queda oculta solo por esta visita.
    }
  }

  return (
    <div className="player-family-tip" role="note" data-no-toast>
      <p>Tu cuenta tiene {count} jugadores. Cámbialos aquí, en «Jugando como».</p>
      <button className="button button--secondary button--sm" type="button" onClick={dismiss}>
        Entendido
      </button>
    </div>
  );
}
